import React from "react";
import PropTypes from "prop-types";

export default function Download(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 17H2.71429V19.4H23.2857V17H25V21H1V17Z" fill="#3965DE" />
      <path
        d="M12.0036 10.9209L9.03332 8.20312L7.66667 9.45353L13 14.3333L18.3333 9.45353L16.9667 8.20304L13.9363 10.9757V1H12.0036V10.9209Z"
        fill="#3965DE"
      />
      <path d="M1 17H2.71429V19.4H23.2857V17H25V21H1V17Z" stroke="#3965DE" />
      <path
        d="M12.0036 10.9209L9.03332 8.20312L7.66667 9.45353L13 14.3333L18.3333 9.45353L16.9667 8.20304L13.9363 10.9757V1H12.0036V10.9209Z"
        stroke="#3965DE"
      />
    </svg>
  );
}

Download.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

Download.defaultProps = {
  className: "",
  width: 168,
  height: 168
};
